<template>
  <b-modal v-model="vModel.ShowSpecialRateDialog" ref="SpecialRate" id="modal-center" class="modal-validation" size="md"
    no-close-on-backdrop="true" no-close-on-esc="true" centered hide-header hide-footer>
    <template v-slot:default>
      <div class="text-center">
        <h4>
          <font color="red">Special Rate!</font>
        </h4>
        <p style="margin-bottom: 0px;">Special Rate Available for {{vModel.SpecialRateDetail.CurrencyCode}}</p>
        <pre class="special__rate">Default Rate:    {{vModel.SpecialRateDetail.DefaultRate}}</pre>
        <pre class="special__rate">Special Rate:    {{vModel.SpecialRateDetail.SpecialRate}}</pre>
        <p>Do you want to proceed?</p>
        <div class="row">
          <div class="col-sm-12 text-center">
            <button class="btn btn-secondary btn-sm center-block special__rate__button" @click="handleNo">NO</button>
            <button class="btn btn-danger btn-sm center-block special__rate__button" @click="handleYes">YES</button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
  import CommonService from "../services/common";
  export default {
    name: "SpecialRateDialog",
    props: ["vModel"],
    methods: {
      handleYes: function (evt) {
        this.vModel.SCurrency = this.vModel.SpecialRateDetail.PayAmount;
        this.vModel.PCurrency = this.vModel.SpecialRateDetail.SendAmount;
        this.vModel.ExchangeRate = this.vModel.SpecialRateDetail.SpecialRate;
        this.vModel.SpecialRateId = this.vModel.SpecialRateDetail.SpecialRateId;
        this.vModel.DefaultRate = this.vModel.SpecialRateDetail.DefaultRate;
        this.vModel.LastSpecialRateDialogClickedButton = "YES";
        this.vModel.ShowSpecialRateDialog = false;
        console.log(this.vModel);
      },
      handleNo: function (evt) {
        this.vModel.SpecialRateId = this.vModel.SpecialRateDetail.SpecialRateId;
        this.vModel.LastSpecialRateDialogClickedButton = "NO";
        this.vModel.ShowSpecialRateDialog = false;
        console.log(this.vModel);
      },
    },
  };
</script>